/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AnalyticService } from '@wb/core/services/analytic.service';

@Component({
  selector: 'app-trash-icon',
  templateUrl: './trash-icon.component.html',
  styleUrls: ['./trash-icon.component.sass'],
})
export class TrashIconComponent {
  @Output() onDelete = new EventEmitter();

  @Input() title?: string;

  @Input() description?: string;

  @Input() track: string[] = [];

  @ViewChild('deleteRef', { static: false }) deleteRef?: TemplateRef<any>;

  dialogRef: MatDialogRef<TrashIconComponent> | undefined;

  constructor(private readonly dialog: MatDialog, private analytics: AnalyticService) {}

  openTrashDialog(event: any) {
    event.stopPropagation();
    if (this.deleteRef) {
      this.dialog.open(this.deleteRef);
    }
    if (this?.track[0] && this?.track[1]) {
      this.analytics.track({
        object: this.track[0],
        action: 'Click',
        properties: { type: `delete_${this.track[1]}` },
      });
    }
  }

  onClick(): void {
    this.onDelete.emit();
    if (this?.track[0] && this?.track[1]) {
      this.analytics.track({
        object: this.track[0],
        action: 'Click',
        properties: { type: `confirm_delete_${this.track[1]}` },
      });
    }
  }
}
